/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-cycle
import { DesktopNavigation, MobileNavigation } from './NavBar';
import { isHelpCenterSection } from '../../utils/pageURLCheck';

const calculateScrollDistance = () => {
  const scrollTop = window.pageYOffset + 63; // how much the user has scrolled by
  const scrollPosition = scrollTop;

  return scrollPosition;
};

function Header({ location, menu }) {
  const [scrollPosition, setScrollPostion] = useState(false);

  useEffect(() => {
    function onScroll() {
      requestAnimationFrame(() => {
        setScrollPostion(calculateScrollDistance());
      });
    }

    window.addEventListener('scroll', onScroll);
    return window.addEventListener('scroll', onScroll);
  }, [scrollPosition]);

  return (
    <>
      {isHelpCenterSection(location.pathname) ? (
        <>
          <DesktopNavigation
            pathname={location.pathname}
            menu={menu}
            helpNavScroll={scrollPosition + 1}
          />
          <MobileNavigation
            pathname={location.pathname}
            menu={menu}
            helpNavScroll={scrollPosition + 1}
          />
        </>
      ) : (
        <>
          <DesktopNavigation pathname={location.pathname} menu={menu} />
          <MobileNavigation pathname={location.pathname} menu={menu} />
        </>
      )}
    </>
  );
}

Header.propTypes = {
  location: PropTypes.shape({
    host: PropTypes.string,
    hostname: PropTypes.string,
    href: PropTypes.string,
    key: PropTypes.string,
    origin: PropTypes.string,
    pathname: PropTypes.string,
    port: PropTypes.string,
  }).isRequired,
  menu: PropTypes.shape({
    links: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default Header;
